import arrowleft from "@Images/NewUI/Vector.png";
import "@Styles/mandate.css";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { withRouter } from "../../../hooks/withRouter";
import { loanHistoryApi } from "../../../Redux/ApplyLoan/action";
import { Loader } from "../Common/Loader";
import LoanHistoryNoData from "./LoanHistoryNoData";

const LoanHistory = (props) => {
  const navigate = useNavigate();
  let token = localStorage.getItem("gpay_token");
  const [loanHistoryData, setLoanHistorydata] = useState([]);
  const [loader, setLoader] = useState(true);
  const [monthShow, setMonthShow] = useState(true);
  const [blockArray, setBlockarray] = useState([]);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 440);

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 440);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleLoanHistory = () => {
    props
      .loanHistoryApi(token)
      .then((res) => {
        setLoader(false);
        setLoanHistorydata(res?.data?.data);
        
        const data = res?.data?.data || [];
        const groupedByMonth = {};
        
        data.forEach((loan) => {
          const monthYear = moment(loan?.tenure_date).format("MM-YY");
          if (!groupedByMonth[monthYear]) {
            groupedByMonth[monthYear] = {
              month: moment(loan?.tenure_date).format("MM"),
              year: moment(loan?.tenure_date).format("YY"),
              value: [],
            };
          }
          groupedByMonth[monthYear].value.push(loan);
        });
        
        const sortedBlocks = Object.values(groupedByMonth).sort((a, b) => {
          const dateA = moment(`${a.month}-${a.year}`, "MM-YY");
          const dateB = moment(`${b.month}-${b.year}`, "MM-YY");
          return dateB - dateA;
        });
        
        setBlockarray(sortedBlocks);
      })
      .catch((err) => {
        setLoader(false);
        if (err.response?.status === 401) {
          // 401 handling (kept as in your code)
        }
        let error = err?.response?.data?.error;
      });
  };

  const monthNumber = (month) => {
    const date = new Date();
    date.setMonth(month - 1);
    return date.toLocaleString("en-US", { month: "short" });
  };

  useEffect(() => {
    handleLoanHistory();
  }, []);

  // 🔹 common navigation handler (used by date row and + icon)
  const goToLoanStatus = (loanId) => {
    navigate("/loanstatusemi", {
      state: { loan_id: loanId },
    });
  };

  return (
    <>
      <div id="background" className="main_div">
        {loader && <Loader />}

        {loanHistoryData.length > 0 && (
          <div
            className="sticky-header shadowlinenew"
            style={{
              display: "flex",
              padding: "30px 0px 30px",
            }}
          >
            <Link>
              <img
                style={{ marginLeft: "30px" }}
                src={arrowleft}
                className="mt-2"
                onClick={() => {
                  navigate(-1);
                }}
              />
            </Link>
            <h1
              className="boldheading mll-25"
              style={{
                paddingLeft: "27px",
                color: "#152745",
                fontWeight: "800",
                fontSize: "25px",
              }}
            >
              Loan History
            </h1>
          </div>
        )}

        {loanHistoryData.length > 0 ? (
          <div className="container">
            <div className="pb-4n ">
              <div className="wrapper-content history_sc">
                <div className="px-4 pb-3 pt-1 w-100 mx-auto bg-white ">
                  <div className="d-flex flex-column justify-content-between">
                    <div className="pt-4 pb-5">
                      {blockArray?.map((item) => (
                        <div
                          className="history_list active"
                          key={item.month + item.year}
                        >
                          <div className="upper_month mb-3">
                            <span className="month">
                              {monthNumber(item.month)}{" "}
                              {item.year}
                            </span>

                            {item.value.map((loanss) => (
                              <div key={loanss?.loan_id}>
                                {/* ROW: left (date + amount) + right (plus btn) */}
                                <div className="lh-row-wrapper">
                                  <div
                                    className="month_left flex align-center"
                                    style={{ marginTop: 21, marginBottom: 21 }}
                                    onClick={() => goToLoanStatus(loanss?.loan_id)}
                                  >
                                    <span
                                      className={loanss?.loan_status === "DISBURSED" ? "date" : "date date_style"}
                                      style={
                                        loanss?.loan_status === "DISBURSED"
                                          ? {
                                              marginRight: 24,
                                              background: "linear-gradient(135deg, hsl(220 100% 55%) 0%, hsl(152 60% 53%) 100%)",
                                              color: "#ffffff",
                                              padding: "10px 15px",
                                              borderRadius: "12px",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              justifyContent: "center",
                                              width: "50px",
                                              height: "50px",
                                              textAlign: "center",
                                              fontWeight: "600",
                                              fontSize: "15px",
                                              WebkitTextFillColor: "#ffffff"
                                            }
                                          : { marginRight: 24 }
                                      }
                                    >
                                      {moment(loanss?.tenure_date).format("DD")}
                                      th
                                    </span>

                                    <div className="money_div setmoney_div">
                                      {loanss?.loan_status !== "DISBURSED" ? (
                                        <span className="money loanamount">
                                          ₹{loanss?.amount}
                                        </span>
                                      ) : (
                                        <span
                                        style={{ background: "linear-gradient(135deg, hsl(220 100% 55%) 0%, hsl(152 60% 53%) 100%)",
                                          WebkitBackgroundClip: "text",
                                          WebkitTextFillColor: "transparent" }}


                                          className="money loanamount"
                                        >
                                          ₹{loanss?.amount}
                                        </span>
                                      )}

                                      {loanss?.loan_status !== "DISBURSED" ? (
                                        <span
                                          className="due_days"
                                          style={{
                                            fontSize: 13,
                                            fontWeight: 400,
                                            color: "#1C1D1C",
                                          }}
                                        >
                                          {loanss?.loan_status}
                                        </span>
                                      ) : (
                                        <span
                                          className="due_days"
                                          style={{
                                            fontSize: 13,
                                            fontWeight: 400,
                                            background: "linear-gradient(135deg, hsl(220 100% 55%) 0%, hsl(152 60% 53%) 100%)",
                                            WebkitBackgroundClip: "text",
                                            WebkitTextFillColor: "transparent"
                                          }}
                                        >
                                          

                                          {loanss?.loan_status}
                                        </span>
                                      )}
                                    </div>
                                  </div>

                                  {/* 🔹 plus button — same redirect */}
                                  <div
                                    className="lh-plus-wrapper"
                                    onClick={() => goToLoanStatus(loanss?.loan_id)}
                                  >
                                    <span>+</span>
                                    {/* or use image:
                                    <img
                                      src={LhPlus}
                                      alt="More details"
                                      className="lh-plus-icon"
                                    />
                                    */}
                                  </div>
                                </div>

                                {/* SEPARATOR LINE */}
                                <div className="lh-row-separator" />
                              </div>
                            ))}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          !loader && (
            <LoanHistoryNoData
              text="Oops!! You don't have any active payment"
              PageText="Loan History"
              history={props.history}
            />
          )
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.user,
  };
};

export default withRouter(connect(mapStateToProps, { loanHistoryApi })(LoanHistory));
